export const ENV = {
    SANDBOX: 'sandbox',
    SANDBOX_KOVENA: 'sandbox-kovena',
    SANDBOX_DEMO: 'sandbox-demo',
    SANDBOX_DEMO_KOVENA: 'sandbox-demo-kovena',
    PROD: 'production',
    STAGING: 'staging',
    STAGING_1: 'staging_1',
    STAGING_2: 'staging_2',
    STAGING_3: 'staging_3',
    STAGING_4: 'staging_4',
    STAGING_5: 'staging_5',
    STAGING_6: 'staging_6',
    STAGING_7: 'staging_7',
    STAGING_8: 'staging_8',
    STAGING_9: 'staging_9',
    STAGING_10: 'staging_10',
    STAGING_11: 'staging_11',
    STAGING_12: 'staging_12',
    STAGING_13: 'staging_13',
    STAGING_14: 'staging_14',
    STAGING_15: 'staging_15',
    STAGING_CBA: 'staging_cba',
    SANDBOX_CBA: 'sandbox_cba',
    PREPROD_CBA: 'preproduction_cba',
    PROD_CBA: 'production_cba',
};
export const WIDGET_URL = [
    { env: ENV.SANDBOX, url: 'https://widget-sandbox.' },
    { env: ENV.SANDBOX_KOVENA, url: 'https://widget-sandbox.' },
    { env: ENV.SANDBOX_DEMO, url: 'https://widget-sandbox-demo.' },
    { env: ENV.SANDBOX_DEMO_KOVENA, url: 'https://widget-sandbox-demo.' },
    { env: ENV.PROD, url: 'https://widget.' },
    { env: ENV.STAGING, url: 'https://widsta.' },
    { env: ENV.STAGING_1, url: 'https://widsta-1.' },
    { env: ENV.STAGING_2, url: 'https://widsta-2.' },
    { env: ENV.STAGING_3, url: 'https://widsta-3.' },
    { env: ENV.STAGING_4, url: 'https://widsta-4.' },
    { env: ENV.STAGING_5, url: 'https://widsta-5.' },
    { env: ENV.STAGING_6, url: 'https://widsta-6.' },
    { env: ENV.STAGING_7, url: 'https://widsta-7.' },
    { env: ENV.STAGING_8, url: 'https://widsta-8.' },
    { env: ENV.STAGING_9, url: 'https://widsta-9.' },
    { env: ENV.STAGING_10, url: 'https://widsta-10.' },
    { env: ENV.STAGING_11, url: 'https://widsta-11.' },
    { env: ENV.STAGING_12, url: 'https://widsta-12.' },
    { env: ENV.STAGING_13, url: 'https://widsta-13.' },
    { env: ENV.STAGING_14, url: 'https://widsta-14.' },
    { env: ENV.STAGING_15, url: 'https://widsta-15.' },
    { env: ENV.STAGING_CBA, url: 'https://widget.staging.powerboard.' },
    { env: ENV.SANDBOX_CBA, url: 'https://widget-sandbox-cba.' },
    { env: ENV.PREPROD_CBA, url: 'https://widget.preproduction.powerboard.' },
    { env: ENV.PROD_CBA, url: 'https://widget.powerboard.' },
];
export const API_URL = [
    { env: ENV.SANDBOX, url: 'https://api-sandbox.' },
    { env: ENV.PROD, url: 'https://api.' },
    { env: ENV.STAGING, url: 'https://apista.' },
    { env: ENV.STAGING_1, url: 'https://apista-1.' },
    { env: ENV.STAGING_2, url: 'https://apista-2.' },
    { env: ENV.STAGING_3, url: 'https://apista-3.' },
    { env: ENV.STAGING_4, url: 'https://apista-4.' },
    { env: ENV.STAGING_5, url: 'https://apista-5.' },
    { env: ENV.STAGING_6, url: 'https://apista-6.' },
    { env: ENV.STAGING_7, url: 'https://apista-7.' },
    { env: ENV.STAGING_8, url: 'https://apista-8.' },
    { env: ENV.STAGING_9, url: 'https://apista-9.' },
    { env: ENV.STAGING_10, url: 'https://apista-10.' },
    { env: ENV.STAGING_11, url: 'https://apista-11.' },
    { env: ENV.STAGING_12, url: 'https://apista-12.' },
    { env: ENV.STAGING_13, url: 'https://apista-13.' },
    { env: ENV.STAGING_14, url: 'https://apista-14.' },
    { env: ENV.STAGING_15, url: 'https://apista-15.' },
    { env: ENV.STAGING_CBA, url: 'https://api.staging.powerboard.' },
    { env: ENV.SANDBOX_CBA, url: 'https://api-sandbox-cba.' },
    { env: ENV.PREPROD_CBA, url: 'https://api.preproduction.powerboard.' },
    { env: ENV.PROD_CBA, url: 'https://api.powerboard.' },
];
const ADDITIONAL_ENV = [ENV.SANDBOX_KOVENA, ENV.SANDBOX_DEMO_KOVENA];
const REGEX_ALIAS = '^([a-zA-Z0-9](?:(?:[a-zA-Z0-9-.]*(?!-)\\.(?![-.]))*[a-zA-Z0-9]+)?)$';
export const DEFAULT_ENV = ENV.SANDBOX;
export const DEFAULT_ALIAS = {
    PAYDOCK: 'paydock.com',
    KOVENA: 'kovena.com',
};
export class Env {
    constructor(configs, defaultEnv = DEFAULT_ENV) {
        this.configs = configs;
        this.setEnv(defaultEnv);
    }
    setEnv(env, alias) {
        if (!this.isValidMode(this.configs, env))
            throw new Error('unknown env: ' + env);
        this.env = env;
        if (alias && !alias.match(REGEX_ALIAS))
            throw new Error('invalid: ' + alias);
        if (alias)
            this.alias = alias;
        else if (ADDITIONAL_ENV.indexOf(this.env) !== -1)
            this.alias = DEFAULT_ALIAS.KOVENA;
        else
            this.alias = DEFAULT_ALIAS.PAYDOCK;
    }
    getEnv() {
        return this.env;
    }
    getConf() {
        for (let index in this.configs) {
            if (!this.configs.hasOwnProperty(index))
                continue;
            if (this.configs[index].env === this.getEnv())
                return {
                    url: (this.configs[index].url.indexOf('localhost') !== -1) ? this.configs[index].url : this.configs[index].url + this.alias,
                    env: this.configs[index].env,
                };
        }
        throw new Error('invalid env');
    }
    isValidMode(configs, env) {
        for (let index in configs) {
            if (!configs.hasOwnProperty(index))
                continue;
            if (configs[index].env === env)
                return true;
        }
        return false;
    }
}
//# sourceMappingURL=../../../src/lib/configs/env/env.js.map